import { classify } from 'sidecar-utilities'

import { Sentiment } from '@sidecar-components/types'

export const viewportStyles = classify({
  // puts toast in bottom center of screen.
  position: 'fixed bottom-0 left-1/2 -translate-x-1/2',
  // --viewport-padding is also used in the slide-in animation
  // padding makes the toast never touch the screen edges
  padding: '[--viewport-padding:_16px] p-[var(--viewport-padding)]',
  width: 'w-full max-w-120',
  multipleToasts: 'flex flex-col gap-2',
  zIndex: 'z-40',
  more: 'list-none outline-none',
})

export const containerStyles = sentiment =>
  classify({
    // container's width is 100% of the screen - 16px on either side so the toast never touches the edge on mobile
    // on larger screens, the toast has a max width
    // by default, the toast is invisible and off screen
    // when shown, the toast animates into visibility and up from the bottom'
    bgColor:
      sentiment === Sentiment.RISK
        ? 'color-highRisk-default'
        : 'color-accent-bold-default',
    flex: 'flex items-center',
    spacing: 'p-4 gap-4',
    styles: 'rounded-lg elevation-2nd-floor',
    focus: 'focus:outline outline-offset-0 outline-4',
    focusColor:
      sentiment === Sentiment.RISK
        ? 'focus:color-outlineRisk-default'
        : 'focus:color-outlineAccent-default',
    animation: 'duration-200 ease-out transition-transform',
    enter: 'data-[state=open]:animate-slide-in',
    leave: 'data-[state=closed]:animate-fade-out-fast',
    swipeGestureMove:
      'data-[swipe=move]:translate-y-[var(--radix-toast-swipe-move-y)]',
    swipeGestureCancel: 'data-[swipe=cancel]:translate-y-0',
    swipeGestureEnd: 'data-[swipe=end]:animate-swipe-out',
  })

export const descriptionStyles = sentiment =>
  classify({
    messageColor:
      sentiment === Sentiment.RISK
        ? 'color-textOnHighRisk-default'
        : 'color-textOnBrand-bold-default',
    font: 'sh-body-sm sh-strong',
    layout: 'w-full',
  })

// remove the default button margins
export const actionStyles = '!m-0'

// change color of accent dismiss icon's focus ring
export const dismissStyles = sentiment =>
  sentiment === Sentiment.RISK
    ? 'focus:after:color-fauxOutlineRisk-default'
    : 'focus:after:color-fauxOutlineBrand-default'

// change color of accent dismiss icon
export const dismissIconStyles = sentiment =>
  classify({
    default:
      sentiment === Sentiment.RISK
        ? 'color-iconOnRisk-default'
        : 'color-iconOnBrand-default',
    hover:
      sentiment === Sentiment.RISK
        ? 'group-hover/button:color-iconOnRisk-hover'
        : 'group-hover/button:color-iconOnBrand-hover',
    active:
      sentiment === Sentiment.RISK
        ? 'group-active/button:color-iconOnRisk-active'
        : 'group-active/button:color-iconOnBrand-active',
    focus:
      sentiment === Sentiment.RISK
        ? 'group-focus/button:color-iconOnRisk-active'
        : 'group-focus/button:color-iconOnBrand-active',
  })
